<div class="fs-2 with-close" mat-dialog-title>
    J'ai une surprise pour vous ! 🎁
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p>
        Je vois que malgré une période d'essai réussie sur LyBox, vous n'avez pas encore choisi un forfait pour continuer à utiliser l'application.<br/>
        <br/>
        Pour vous aider à passer à l'action, j'ai décidé de vous faire un cadeau ! 🎁
    </p>
    <div class="text-center mb-4">
        <h3>
            Je vous offre 20% de réduction<br/>
            sur l'abonnement de votre choix !
        </h3>
        <i>Offre valable pendant 3 mois, ou bien pendant 1 an si vous prenez un abonnement annuel.</i>
    </div>
    <p>
        Cette offre est à durée limitée, et sera automatiquement désactivée ensuite. ⏰
    </p>
    <p>
        En immobilier, il faut savoir saisir les opportunités car les bonnes affaires n'attendent pas !
    </p>
    <p class="mb-0">
        PS : La promotion s’applique automatiquement, pas besoin de code promo
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onYesClick()" class="btn btn-primary w-100">
        Profiter de -20% offerts
    </button>
</div>
